<template>
	<div>
		<PageHeader
			:data="{
				name: campaign.name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Campaigns', to: '/campaigns' },
				],
			}"
		/>
		<!-- Campaign - SCHEDULED -->
		<div v-if="campaign.status == 'scheduled'" class="row">
			<div class="col-md-8 text-center">
				<h2>Campaign is scheduled for sending</h2>
				<h4 class="mb-4">
					Campaign will be sent: <font-awesome-icon v-if="loadingCampaign" :icon="['fas', 'spinner']" :class="['fa-spin']" /><template v-else>{{
						campaign.scheduled_date
					}}</template>
				</h4>

				<div class="alert alert-info bg-info-lighter text-dark mb-3 mt-2">
					💡 Deliveries are prepared for sending and will be sent <font-awesome-icon v-if="loadingCampaign" :icon="['fas', 'spinner']" :class="['fa-spin']" /><template
						v-else
						>{{ campaign.scheduled_date }}</template
					>
					.If there is any problem with the campaign or if the campaign needs to be canceled, it is best and recommended to do so now. After the campaign enters the
					sending process, it will still be possible to cancel, but with more limitations.
				</div>
				<button @click="cancelSchedule()" class="btn btn-secondary btn-lg rounded">✋ Cancel</button>
			</div>
			<div class="col-md-4">
				<div class="row">
					<div class="col-md-10">
						<div class="alert alert-info bg-info-lighter text-dark mb-3 mt-2 text-center">
							<h5 class="text-center text-dark">Campaign Info</h5>
							<p class="p-0 m-0">
								Name: <b> {{ campaign.name }} </b>
							</p>
							<p class="p-0 m-0">
								Type: <b>{{ campaign.type }}</b>
							</p>
							<p class="p-0 m-0">
								Sender: <b>{{ campaign.sender }}</b>
							</p>
							<p class="p-0 m-0">
								Estimated Costs: <br />
								<b class="text-success fs-3">~ ${{ campaign.estimated_costs }}</b>
							</p>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-12 my-5">
				<!-- Delivery Objects -->
				<div class="col-md-12 mb-3">
					<div class="delivery-objects">
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<div class="d-flex justify-content-between align-items-center mb-2">
									<div>
										<small
											>Initial Source: <span class="text-capitalize">{{ campaign.source }}</span></small
										>
										<h4 class="mb-2 d-flex justify-content-start align-items-center">
											Delivery Objects <span class="badge bg-primary ms-2">{{ campaign.municipalities_count }}</span>
										</h4>
									</div>
								</div>
							</div>
						</div>

						<table :class="!loading && deliveryObjects.length > 0 ? 'table table-hover' : 'table table-hover loading'">
							<thead>
								<tr>
									<th class="text-center">ID</th>
									<th>Name</th>
									<th>City</th>
									<th>Address</th>
									<th>Zip</th>
									<th class="text-center">State</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="dObject in deliveryObjects">
									<tr
										:key="'edit-' + dObject.id"
										:class="{
											'bg-danger-light':
												(dObject.city == '' || dObject.city == null) &&
												(dObject.address == '' || dObject.address == null) &&
												(dObject.zip == '' || dObject.zip == null),
											'bg-warning-light':
												dObject.city != '' &&
												dObject.city != null &&
												(dObject.address == '' || dObject.address == null) &&
												(dObject.zip == '' || dObject.zip == null),
											'bg-warning-lighter':
												(dObject.city == '' || dObject.city == null) &&
												dObject.address != '' &&
												dObject.address != null &&
												dObject.zip != '' &&
												dObject.zip != null,
										}"
									>
										<td class="text-center align-middle">
											{{ dObject.id }}
										</td>
										<td class="align-middle">
											<h6 class="p-0 m-0 d-flex justify-content-start align-items-center">
												{{ dObject.name }}
												<span
													v-if="
														(dObject.city == '' || dObject.city == null) &&
															(dObject.address == '' || dObject.address == null) &&
															(dObject.zip == '' || dObject.zip == null)
													"
													class="btn btn-sm ms-2"
													title="A lot of data is missing for this Delivery Object. The delivery will not be sent to this delivery object for sure."
												>
													<font-awesome-icon :class="['text-danger fs-4']" :icon="['fas', 'exclamation-triangle']" />
												</span>
												<span
													class="btn btn-sm ms-2"
													title="Important data is missing for this Object Delivery. The delivery will not be sent to this delivery object for sure."
													v-else-if="(dObject.address == '' || dObject.address == null) && (dObject.zip == '' || dObject.zip == null)"
												>
													<font-awesome-icon :class="['text-warning fs-4 ms-2']" :icon="['fas', 'exclamation-circle']" />
												</span>
												<span
													class="btn btn-sm ms-2"
													title="The city is missing; it's nice to have but not mandatory if all other data is available."
													v-else-if="dObject.city == '' || dObject.city == null"
												>
													<font-awesome-icon :class="['text-warning fs-6 ms-2']" :icon="['fas', 'exclamation']" />
												</span>
											</h6>
										</td>
										<td class="align-middle">{{ dObject.city }}</td>
										<td class="align-middle">{{ dObject.address }}</td>
										<td class="align-middle">{{ dObject.zip }}</td>
										<td class="text-center align-middle">{{ dObject.state }}</td>
									</tr>
								</template>
							</tbody>
						</table>
						<div v-if="loading && deliveryObjects.length === 0" class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
						<LPDataTablePagination :pagination="pagination" v-on:getItems="getItems($event.page)" />
					</div>
				</div>
			</div>
		</div>
		<!-- #Campaign - SCHEDULED -->
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
//import { Modal } from 'bootstrap'
import LPDataTablePagination from '@/components/lp-data-table/LPDataTablePagination'
//import Editor from '@tinymce/tinymce-vue'

export default {
	name: 'CampaignScheduled',
	components: { PageHeader, LPDataTablePagination /*, Editor,*/ },
	data() {
		return {
			loading: false,
			loadingCampaign: false,
			campaign: {},
			params: {},
			pagination: {},
			page: this.$route.query.page || 1,
			deliveryObjects: [],
			intervalId: null,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
		totalSentDeliveryObjects() {
			return this.deliveryObjectsCount - this.deliveryErrorsCount - this.deliveryCanceledCount
		},
	},
	mounted: function() {
		this.intervalId = setInterval(() => {
			console.log('Ovo je iz Scheduled!')
			if (this.campaign.status == 'scheduled') {
				this.getCampaign()
			}
		}, 10000)
	},
	beforeDestroy() {
		// Stop the interval when the component is about to be destroyed
		clearInterval(this.intervalId)
	},
	created() {
		this.getCampaign()
		this.getDeliveryObjects()
	},
	methods: {
		/**
		 * Get Campaign
		 * Function get selected campaign data
		 */
		getCampaign() {
			this.loadingCampaign = true
			restApi
				.get(`/campaigns/${this.$route.params.id}`)
				.then(({ data }) => {
					this.campaign = data
					// If campaign status is "sending"
					if (data.status == 'sending') {
						this.$router.push(`/campaigns/sending/${this.$route.params.id}`)
					}
					this.loadingCampaign = false
				})
				.catch(error => {
					console.log(error)
				})
		},

		// Cancel scheduled campaign
		cancelSchedule() {
			this.$swal
				.fire({
					title: 'Are you sure want to cancel this scheduled campaign?',
					text: `Campaign will be returned to preparing status!`,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, cancel it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						this.campaign.status = 'preparing'
						this.campaign.send_at = null
						this.campaign.scheduled_at = null
						restApi
							.put(`/campaigns/${this.$route.params.id}`, this.campaign)
							.then(({ data }) => {
								delete data.changes.updated_at
								delete data.changes.filters
								this.$router.push(`/campaigns/edit/${this.$route.params.id}`)
							})
							.catch(error => {
								console.log(error)
							})
					}
				})
		},

		/**
		 * Get Delivery Objects
		 * Function getting all Delivery Objects for current campaign
		 */
		getDeliveryObjects() {
			this.loading = true
			this.params = {
				page: this.page,
				search: this.deliveryObjectSearch,
			}
			restApi
				.get(`/campaigns/${this.$route.params.id}/delivery-objects`, { params: this.params })
				.then(({ data }) => {
					this.deliveryObjects = data.data
					this.pagination = data
					delete this.pagination.data
					this.loading = false
					//this.$router.push({ path: this.$router.currentPath, query: this.params })
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Get items from page that returned from LPDataTablePagination
		getItems(page) {
			this.page = page
			this.getDeliveryObjects()
		},
	},

	watch: {},
}
</script>
